import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  required,
} from 'react-admin';

export const CaseCategoryCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput
        source="name"
        validate={[required()]}
        fullWidth
      />
      <TextInput
        source="slug"
        fullWidth
        helperText="Будет сгенерирован автоматически, если не указан"
      />
      <BooleanInput
        source="isActive"
        defaultValue={true}
      />
      <NumberInput
        source="sortOrder"
        defaultValue={0}
        min={0}
      />
    </SimpleForm>
  </Create>
);
